import { Icon, Input, InputGroup } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';

export const SearchInput = ({ search }: { search: string }) => {
  const [searchValue, setSearchValue] = useState<string>(search);
  const navigate = useNavigate();

  const handleSearch = () => {
    navigate({
      // @ts-ignore
      search: (prev: Record<string, string>) => ({
        ...prev,
        search: searchValue,
      }),
    });
  };

  useEffect(() => {
    setSearchValue(search);
  }, [search]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleSearch();
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchValue]);

  return (
    <InputGroup
      w="250px"
      startElement={
        <Icon cursor={'pointer'} _hover={{ color: 'primary' }} onClick={handleSearch}>
          <FaSearch />
        </Icon>
      }
    >
      <Input
        size="sm"
        placeholder={t('ui.search')}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        autoFocus
      />
    </InputGroup>
  );
};
